<template>
  <OrderUpDiv>
    <OrderUpClientArea>
      <OrderUpTitleArea>
        <OrderUpTitleDiv>주문서 입력</OrderUpTitleDiv>
      </OrderUpTitleArea>

      <!-- !수급자 불러오기 버튼 -->
      <OrderUpClientBtnContainer>
        <OrderUpClientUpBtn @click="showModal_obj.client_up = true" class="clientUpBtn">
          한큐 불러오기
        </OrderUpClientUpBtn>
        <OrderUpClientUpBtn @click="showModal_obj.company_up = true">
          거래처 불러오기
        </OrderUpClientUpBtn>
      </OrderUpClientBtnContainer>

      <!-- !수급자 정보 테이블 -->
      <OrderUpClientTable>
        <thead></thead>
        <tbody>
          <tr>
            <OrderUpClientTableTd>주문일자</OrderUpClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.orderdate" placeholder="주문일자" style="width:130px;height:35px;"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }"
                :lang="ko" />
            </td>
            <OrderUpClientTableTd>인정번호</OrderUpClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" placeholder="요양인정번호 10자리" v-model="client_data_obj.number"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderUpClientTableTd>고객성함</OrderUpClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.name" @focus="disableBarcodeScanner"
                @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
            <OrderUpClientTableTd>보호자성함</OrderUpClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.guardname" @focus="disableBarcodeScanner"
                @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr v-if="hasRentalProduct">
            <OrderUpClientTableTd>대여 시작일</OrderUpClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.rental_start" placeholder="" style="width:130px;height:35px;"
                :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
            <OrderUpClientTableTd>대여 종료일</OrderUpClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.rental_end" placeholder="" style="width:130px; height:35px;"
                :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
          </tr>
          <tr v-if="hasRentalProduct && hasOxygenGenerator">
            <OrderUpClientTableTd>산소치료<br>처방시작일</OrderUpClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.oxygen_start" placeholder="" style="width:130px;height:35px;"
                :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
            <OrderUpClientTableTd>산소치료<br>처방종료일</OrderUpClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.oxygen_end" placeholder="" style="width:130px; height:35px;"
                :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
          </tr>
          <tr v-if="hasDiabetesProduct">
            <OrderUpClientTableTd>당뇨소모성재료<br>처방시작일</OrderUpClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.diabetes_start" placeholder="" style="width:130px;height:35px;"
                :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
            <OrderUpClientTableTd>당뇨소모성재료<br>처방종료일</OrderUpClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.diabetes_end" placeholder="" style="width:130px; height:35px;"
                :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
          </tr>
          <tr>
            <OrderUpClientTableTd>주소1<br>(배송주소)</OrderUpClientTableTd>
            <td>
              <orderUpClientAddressBtn @click="openDaumPostcode(1)">주소 검색</orderUpClientAddressBtn>
              <OrderUpClientInputTxtW150 v-model="postcode_obj.postcode1" type="text" placeholder="우편번호"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" /><br>
            </td>
            <td colspan="2">
              <OrderUpClientInputTxtW260 v-model="postcode_obj.address1" type="text" placeholder="주소"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
              <OrderUpClientInputTxtW260 v-model="postcode_obj.detailAddress1" type="text" placeholder="상세주소"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderUpClientTableTd>주소2</OrderUpClientTableTd>
            <td>
              <orderUpClientAddressBtn @click="openDaumPostcode(2)">주소 검색</orderUpClientAddressBtn>
              <OrderUpClientInputTxtW150 v-model="postcode_obj.postcode2" type="text" placeholder="우편번호"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" /><br>
            </td>
            <td colspan="2">
              <OrderUpClientInputTxtW260 v-model="postcode_obj.address2" type="text" placeholder="주소"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
              <OrderUpClientInputTxtW260 v-model="postcode_obj.detailAddress2" type="text" placeholder="상세주소"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderUpClientTableTd>이메일</OrderUpClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.email" @focus="disableBarcodeScanner"
                @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
            <OrderUpClientTableTd>고객관계</OrderUpClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.guardtarget"
                @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderUpClientTableTd>연락처1</OrderUpClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.phone1" @focus="disableBarcodeScanner"
                @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
            <OrderUpClientTableTd>연락처2</OrderUpClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.phone2" @focus="disableBarcodeScanner"
                @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderUpClientTableTd>센터명</OrderUpClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.centername" @focus="disableBarcodeScanner"
                @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }" />
            </td>
            <OrderUpClientTableTd>담당자</OrderUpClientTableTd>
            <td>
              <OrderUpClientSelectW162 v-model="client_data_obj.manager" @focus="disableBarcodeScanner"
                @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }">
                <option v-for="manager in manager" :key="manager.name" :value="manager.name">{{ manager.name }}</option>
              </OrderUpClientSelectW162>
            </td>
          </tr>
          <tr>
            <OrderUpClientTableTd>배송방법</OrderUpClientTableTd>
            <td>
              <OrderUpClientSelectW162 v-model="client_data_obj.deliveryMethod" @focus="disableBarcodeScanner"
                @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }">
                <option value="내방">내방</option>
                <option value="물류 (기관배송)">물류 (기관배송)</option>
                <option value="택배">택배</option>
                <option value="소독">소독</option>
                <option value="공급업체">공급업체</option>
              </OrderUpClientSelectW162>
            </td>
            <OrderUpClientTableTd>배송요청 <br>(일 / 시)</OrderUpClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.delivery_date" placeholder="배송요청일시"
                style="width:130px;height:35px;" @focus="disableBarcodeScanner" @blur="enableBarcodeScanner"
                :class="{ 'blurred': isTestUser }" :lang="ko" /><br />
              <OrderUpClientSelectW162 v-model="client_data_obj.delivery_time" :class="{ 'blurred': isTestUser }">
                <option value="0">오전</option>
                <option value="1">오후</option>
              </OrderUpClientSelectW162>
            </td>
          </tr>

          <!-- !메모 영역 -->
          <OrderUpClientTableTr>
            <OrderUpClientTableTd>메모</OrderUpClientTableTd>
            <td colspan="3">
              <CommentContainer class="comment-container">
                <CommentThumbnailArea>
                  <CommentThumbnail v-for="(file, index) in imageFiles" :key="index" class="thumbnail">
                    <div>
                      <img :src="imageHandlingGetImageUrl(file)" alt="썸네일">
                      <button @click="imageHandlingRemoveImage(index)" @focus="disableBarcodeScanner"
                        @blur="enableBarcodeScanner">삭제</button>
                    </div>
                  </CommentThumbnail>
                </CommentThumbnailArea>
                <CommentImageUploadArea class="image-upload">
                  <input type="file" @change="imageHandlingOnFileSelected" @focus="disableBarcodeScanner"
                    accept="image/*" multiple ref="fileInput" style="display: none;">
                  <button @click="handleImageUploadClick" @focus="disableBarcodeScanner" @blur="enableBarcodeScanner">
                    <Attachment />이미지 첨부
                  </button>
                </CommentImageUploadArea>
                <OrderCommentTextarea rows="4" v-model="orderComment" @focus="disableBarcodeScanner"
                  @blur="enableBarcodeScanner" :class="{ 'blurred': isTestUser }"></OrderCommentTextarea>
              </CommentContainer>
            </td>
          </OrderUpClientTableTr>
        </tbody>
      </OrderUpClientTable>
    </OrderUpClientArea>

    <!-- !센터 영역 -->
    <OrderUpCenterArea></OrderUpCenterArea>

    <!-- !품목 영역 -->
    <OrderUpProductArea>
      <StoreOrderArea>
        <SectionTitle2>매장 주문</SectionTitle2>
        <OrderUpProductHeaderArea>
          <FlexDiv>
            <OrderUpProductHeaderBtn @click="selectAllStore">전체선택</OrderUpProductHeaderBtn>&nbsp;
            <OrderUpProductHeaderBtn @click="deselectAllStore">선택해제</OrderUpProductHeaderBtn>&nbsp;
            <OrderUpProductHeaderBtn @click="openClaimModal">청구계산</OrderUpProductHeaderBtn>
          </FlexDiv>
          <div></div>
          <OrderUpProductHeaderBtn @click="deleteSelectedStoreProducts">선택품목삭제</OrderUpProductHeaderBtn>
        </OrderUpProductHeaderArea>

        <OrderUpProductTableContainer>
          <OrderUpProductTable>
            <thead>
              <OrderUpProductTableTheadTr>
                <th>
                  <OrderUpProductTableCheckbox type="checkbox" :checked="isAllSelected" @change="toggleAllSelection"
                    title="전체 선택/해제" />
                </th>
                <th>거래처</th>
                <th>바코드</th>
                <th>품목분류</th>
                <th>품목명</th>
                <th>사이즈</th>
                <th>색상</th>
                <th>비고</th>
                <th>수량</th>
                <th>단가</th>
                <th>차액</th>
                <th>품목 합계</th>
                <th></th>
                <th>상세</th>
              </OrderUpProductTableTheadTr>
            </thead>
            <tbody>
              <template v-for="(product, index) in store_products" :key="index">
                <tr class="main-row" :class="{ 'expanded': product.expanded }">
                  <!-- *선택 -->
                  <td>
                    <OrderUpProductTableInput type="checkbox" :checked="product.selected"
                      @change="toggleProductSelection(index)" />
                  </td>
                  <!-- *품목코드 -->
                  <td>{{ product.company }}</td>
                  <!-- *바코드 -->
                  <td>
                    <!-- 비급여 품목인 경우 수량과 관계없이 고정 표시 -->
                    <template v-if="product.num >= 100000">
                      <OrderUpProductTableBcodeAreaDiv>
                        <OrderUpProductTableInputTxt type="text" v-model="product.barcodes[0]"
                          :placeholder="product.name0?.startsWith('당뇨용품') ? '바코드 (보험코드)' : '바코드'"
                          @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" />
                      </OrderUpProductTableBcodeAreaDiv>
                    </template>
                    <!-- 급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <OrderUpProductTableBcodeAreaDiv v-for="n in product.quantity" :key="`barcode-${index}-${n}`">
                        <OrderUpProductTableInputTxt type="text" v-model="product.barcodes[n - 1]"
                          :placeholder="product.name0?.startsWith('당뇨용품') ? '바코드 (보험코드)' : '바코드'"
                          @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" />
                      </OrderUpProductTableBcodeAreaDiv>
                    </template>
                  </td>
                  <!-- *품목분류 -->
                  <td :title="`${product.b_product_id > 999999 ? product.name2 : product.name0}`">
                    <!-- 급여 품목인 경우 품목코드와 pitem 표시 -->
                    <template v-if="product.num < 1000000 || product.pitem">
                      <div style="font-size: 12px; color: #666; margin-bottom: 2px;">
                        {{ product.pcode }}
                      </div>
                      <div>{{ product.pitem }}</div>
                    </template>
                    <!-- 비급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <div style="font-size: 12px; color: #666; margin-bottom: 2px;">
                        {{ product.code }}
                      </div>
                      <div>{{ product.name1 }}</div>
                    </template>
                  </td>
                  <!-- *품목명 -->
                  <ProductNameCell :title="`${product.b_product_id > 999999 ? product.name3 : product.name}`"
                    @mouseenter="showProductImage($event, product)" @mouseleave="hideProductImage"
                    @click="showProductImage($event, product)"
                    style="cursor:pointer; position: relative; overflow: hidden; text-overflow: ellipsis;">
                    <div class="image-trigger" style="display: inline-block; width: 100%;">
                      {{ product.b_product_id > 999999 ? product.name3 : product.name2 }}
                    </div>
                  </ProductNameCell>
                  <!-- *사이즈 -->
                  <td>
                    <!-- 비급여 품목인 경우 수량과 관계없이 고정 표시 -->
                    <template v-if="product.num >= 100000">
                      <div>
                        <OrderUpProductTableInputTxt v-if="product.sizeOptions && product.sizeOptions.length > 0"
                          v-model="product.sizes[0]" @input="convertToUpperCase(index, 0)"
                          @focus="disableBarcodeScanner" @blur="enableBarcodeScanner">
                        </OrderUpProductTableInputTxt>
                      </div>
                    </template>
                    <!-- 급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <div v-for="n in product.quantity" :key="`size-${index}-${n}`">
                        <OrderUpProductTableInputTxt v-if="product.sizeOptions && product.sizeOptions.length > 0"
                          v-model="product.sizes[n - 1]" @input="convertToUpperCase(index, n - 1)"
                          @focus="disableBarcodeScanner" @blur="enableBarcodeScanner">
                        </OrderUpProductTableInputTxt>
                      </div>
                    </template>
                  </td>
                  <!-- *색상 -->
                  <td>
                    <!-- 비급여 품목인 경우 수량과 관계없이 고정 표시 -->
                    <template v-if="product.num >= 100000">
                      <div>
                        <OrderUpProductTableColorSelect v-if="product.colorOptions && product.colorOptions.length > 0"
                          v-model="product.colors[0]" class="color_select">
                          <option v-for="color in product.colorOptions" :key="color" :value="color">{{ color }}</option>
                        </OrderUpProductTableColorSelect>
                      </div>
                    </template>
                    <!-- 급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <div v-for="n in product.quantity" :key="`color-${index}-${n}`">
                        <OrderUpProductTableColorSelect v-if="product.colorOptions && product.colorOptions.length > 0"
                          v-model="product.colors[n - 1]" class="color_select">
                          <option v-for="color in product.colorOptions" :key="color" :value="color">{{ color }}</option>
                        </OrderUpProductTableColorSelect>
                      </div>
                    </template>
                  </td>
                  <!-- *비고 -->
                  <td>
                    <!-- 비급여 품목인 경우 수량과 관계없이 고정 표시 -->
                    <template v-if="product.num >= 100000">
                      <div>
                        <OrderUpProductTableInputTxt type="text" v-model="product.notes[0]"
                          @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :placeholder="`비고`" />
                      </div>
                    </template>
                    <!-- 급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <div v-for="n in product.quantity" :key="`note-${index}-${n}`">
                        <OrderUpProductTableInputTxt type="text" v-model="product.notes[n - 1]"
                          @focus="disableBarcodeScanner" @blur="enableBarcodeScanner" :placeholder="`비고`" />
                      </div>
                    </template>
                  </td>
                  <!-- *수량 -->
                  <td>
                    <QuantityFlexDiv>
                      <OrderupProductCntInput type="text" v-model="product.quantity"
                        @input="handleStoreQuantityChange(index, $event.target.value)" @focus="disableBarcodeScanner"
                        @blur="enableBarcodeScanner" />
                      <QuantityButtonContainer>
                        <HanqBtn @click="decreaseStoreQuantity(index)">-</HanqBtn>
                        <HanqBtn @click="increaseStoreQuantity(index)">+</HanqBtn>
                      </QuantityButtonContainer>
                    </QuantityFlexDiv>
                  </td>
                  <!-- *단가 -->
                  <td>
                    <FlexDiv>
                      <div v-if="!product.isEditingPrice" @click="startEditingPrice(index)" style="cursor: pointer;">
                        {{ format.price(product.unitprice) }}원
                      </div>
                      <div v-else>
                        <input :value="product.unitprice" :ref="el => { if (el) priceInputs[index] = el }"
                          @input="updatePrice(index, $event.target.value)" @blur="finishEditingPrice(index)"
                          @keyup.enter="finishEditingPrice(index)"
                          style="width: 50px; text-align: right; height: 20px; border: 1px solid #ddd; border-radius: 4px;" />원
                      </div>
                    </FlexDiv>
                  </td>
                  <!-- *차액 -->
                  <td>
                    <span
                      :class="{ 'positive-diff': getTotalPriceDifference(product) > 0, 'negative-diff': getTotalPriceDifference(product) < 0 }">
                      {{ getTotalPriceDifference(product) > 0 ? '+' : '' }}{{
                        format.price(getTotalPriceDifference(product)) }}원
                    </span>
                  </td>
                  <!-- *품목 합계 -->
                  <td>
                    <FlexDiv>
                      {{ format.price(perItemTotalPrice(product)) }}원
                    </FlexDiv>
                  </td>
                  <!-- *삭제 -->
                  <td>
                    <DeleteButton @click.stop="deleteProduct(index)">
                      <Delete />
                    </DeleteButton>
                  </td>
                  <!-- *상세 버튼 -->
                  <td>
                    <ExpandButton @click="toggleProductExpand(index)" :class="{ 'expanded': product.expanded }">
                      <ChevronDown v-if="!product.expanded" />
                      <ChevronUp v-else />
                    </ExpandButton>
                  </td>
                </tr>

                <!-- ! 확장된 행 -->
                <tr v-if="product.expanded">
                  <td :colspan="14">
                    <div class="product-expanded-row">
                      <div class="product-card-grid">
                        <!-- * 가격 정보 카드 -->
                        <div class="product-info-card">
                          <h4 class="product-card-title">가격 정보</h4>
                          <div class="product-price-row">
                            <div class="product-price-item">
                              <div class="product-info-label">구입가격</div>
                              <div class="product-price-value">{{ format.price(product.buyprice || product.price || '0')
                              }}원</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">대여가격</div>
                              <div class="product-price-value">{{ format.price(product.rentprice || product.price2 ||
                                '0') }}원</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">공급가격</div>
                              <div class="product-price-value">{{ format.price(product.supplyprice || product.price3 ||
                                '0') }}원</div>
                            </div>
                            <div class="product-price-item" v-if="product.type === '박스'">
                              <div class="product-info-label">낱개 당 가격</div>
                              <div class="product-price-value">{{ calculateUnitPrice(product) }}원</div>
                            </div>
                          </div>
                        </div>

                        <!-- * 수량 정보 카드 -->
                        <div class="product-info-card">
                          <h4 class="product-card-title">수량 정보</h4>
                          <div class="product-price-row">
                            <div class="product-price-item">
                              <div class="product-info-label">
                                {{ product.type === '박스' ? '박스 수량' : '품목 수량' }}
                              </div>
                              <div class="product-price-value">{{ product.quantity || 0 }}개</div>
                            </div>
                            <div class="product-price-item" v-if="product.type === '박스'">
                              <div class="product-info-label">박스 당 개수</div>
                              <div class="product-price-value">{{ product.pieces_per_box || 0 }}개</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">낱개 수량</div>
                              <div class="product-price-value">{{ product.piece_quantity || 0 }}개</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">합계 수량</div>
                              <div class="product-price-value">{{ calculateTotalQuantity(product) }}개</div>
                            </div>
                          </div>
                        </div>

                        <!-- * 재고 정보 카드 -->
                        <div class="product-info-card">
                          <h4 class="product-card-title">재고 정보</h4>
                          <div class="product-price-row">
                            <div class="product-price-item">
                              <div class="product-info-label">재고 위치</div>
                              <div class="product-price-value">{{ product.location || '미지정' }}</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">재고 수량</div>
                              <div class="product-price-value">{{ product.stock_quantity || 0 }}개</div>
                            </div>
                          </div>
                        </div>

                        <!-- * 가상계좌 정보 카드 -->
                        <div class="product-info-card">
                          <h4 class="product-card-title">가상계좌 정보</h4>
                          <div class="product-price-row">
                            <div class="product-price-item">
                              <div class="product-info-label">발송 여부</div>
                              <label class="product-toggle-switch">
                                <input type="checkbox" v-model="product.claimYn" :id="`billing-toggle-${index}`" />
                                <span class="slider"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </OrderUpProductTable>
        </OrderUpProductTableContainer>

        <!-- * 이미지 미리보기 컴포넌트 -->
        <ProductImagePreview v-if="imagePreviewUrl" :style="imagePreviewStyle">
          <ProductPreviewImg :src="imagePreviewUrl" alt="제품 이미지" />
        </ProductImagePreview>

        <!-- ! 매장 합계 정보 영역 -->
        <OrderTotalArea>
          <TotalInfoContainer>
            <TotalInfoItem>
              <span>결제 수단:</span>
              <PaymentMethodContainer>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="현금" name="storePaymentMethod">
                  현금
                </PaymentMethodLabel>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="가상계좌" name="storePaymentMethod">
                  가상계좌
                </PaymentMethodLabel>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="카드" name="storePaymentMethod">
                  카드
                </PaymentMethodLabel>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="기타" name="storePaymentMethod">
                  기타
                </PaymentMethodLabel>
              </PaymentMethodContainer>
            </TotalInfoItem>
            <SummaryRightContainer>
              <TotalInfoItem>
                <span>총 수량:</span>
                <span>{{ totalStoreQuantity }}개</span>
              </TotalInfoItem>
              <TotalInfoItem>
                <span>합계:</span>
                <span>{{ format.price(totalStorePrice) }}원</span>
              </TotalInfoItem>
            </SummaryRightContainer>
          </TotalInfoContainer>
        </OrderTotalArea>

        <!-- ! 매장 품목추가 영역 -->
        <OrderUpProductUpArea>
          <OrderUpPorudctUpBtn @click="openStoreProductModal">
            <Plus />&nbsp;품목추가
          </OrderUpPorudctUpBtn>
        </OrderUpProductUpArea>
      </StoreOrderArea>

      <!-- ! 주문하기 영역 -->
      <OrderUpSubmitArea>
        <OrderButton @click="submitOrder()">
          <ButtonIcon>✓</ButtonIcon>
          <ButtonText>일반 주문</ButtonText>
        </OrderButton>
        <OxygenButton @click="submitOrder('o')">
          <ButtonIcon>✓</ButtonIcon>
          <ButtonText>산소발생기 주문</ButtonText>
        </OxygenButton>
        <MedicalDeviceButton @click="submitOrder('a')">
          <ButtonIcon>✓</ButtonIcon>
          <ButtonText>보장구 주문</ButtonText>
        </MedicalDeviceButton>
        <DiabetesButton @click="submitOrder('d')">
          <ButtonIcon>✓</ButtonIcon>
          <ButtonText>당뇨소모성재료 주문</ButtonText>
        </DiabetesButton>
      </OrderUpSubmitArea>

      <!-- *수급자 불러오기 모달 -->
      <ModalPage v-model:show="showModal_obj.client_up" :width="modal_width.client_up" :height="modal_height.client_up">
        <ClientGetPage @clientDetail="handleClientDetail" @close="showModal_obj.client_up = false" />
      </ModalPage>
      <!-- *거래처 불러오기 모달 -->
      <ModalPage v-model:show="showModal_obj.company_up" :width="modal_width.company_up"
        :height="modal_height.company_up">
        <CompanyGetPage @companyDetail="handleCompanyDetail" @close="showModal_obj.company_up = false" />
      </ModalPage>
      <!-- * 품목추가 모달 -->
      <ModalPage v-model:show="showModal_obj.product_up" :width="modal_width.product_up"
        :height="modal_height.product_up">
        <ProductGetPage @productDetail="handleProductDetail" @selectTarget="handleTargetSelection"
          :existingProducts="products_obj" @close="showModal_obj.product_up = false" />
      </ModalPage>
      <!-- * 청구계산 팝업 -->
      <ModalPage v-model:show="showModal_obj.claim_up" :width="modal_width.claim_up" :height="modal_height.claim_up">
        <ClaimCalculationPopup :show="showModal_obj.claim_up" :selectedProducts="getSelectedProductsForClaim()"
          @close="handleClaimModalClose()" />
      </ModalPage>
    </OrderUpProductArea>
  </OrderUpDiv>
</template>

<script>
import { ref, reactive } from 'vue';
import onScan from 'onscan.js';
import * as injectGlobal from '@/assets/styles/global/public.js';
import * as OrderUpCss from '@/assets/styles/order/OrderUpCss.js';
import { ProductExpandedRowStyles } from "@/assets/styles/order/OrderModifyCss.js";;

// 모달 컴포넌트
import ModalPage from '@/components/layout/ModalPage.vue';
import ClientGetPage from '@/components/order/modal/ClientGetModal.vue';
import CompanyGetPage from '@/components/order/modal/CompanyGetModal.vue';
import ProductGetPage from '@/components/product/modal/ProductGetModal.vue';
import ClaimCalculationPopup from '@/components/order/popup/ClaimCalculationPopup.vue';

// 아이콘 컴포넌트
import Datepicker from 'vue-datepicker-next';
import Attachment from 'vue-material-design-icons/Attachment.vue';
import Plus from 'vue-material-design-icons/Plus.vue';
import Delete from 'vue-material-design-icons/Delete.vue';
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue';
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue';

export default {
  components: {
    ...injectGlobal,
    ...OrderUpCss,
    ClaimCalculationPopup,
    ModalPage,
    ClientGetPage,
    CompanyGetPage,
    ProductGetPage,
    Attachment, Plus, Delete,
    Datepicker,
    ChevronDown,
    ChevronUp,
    ProductExpandedRowStyles
  },
  props: ['client'],

  setup() {
    const isInitialized = ref(false);
    const clientUpBtn = ref(null);
    const color_obj = reactive({});
    const products_obj = ref([]);
    const orderComment = ref('');
    const priceInputs = ref([]);     // 가격 입력 배열
    const store_products = ref([]);  // 매장 제품 배열 추가
    const storePaymentMethod = ref('현금'); // 결제 수단 초기값
    // 매장 품목 추가 모달 열기
    const openStoreProductModal = () => {
      showModal_obj.product_up = true;
    };
    // 청구 계산 모달 열기
    const openClaimModal = () => {
      showModal_obj.claim_up = true;
    };
    const client_data_obj = reactive({
      name: '매장',
      number: '00000000',
      regident: '',
      email: '',
      address: '',
      guardname: '',
      guardtarget: '',
      rental_start: new Date(),
      rental_end: (() => {
        const start = new Date();
        const end = new Date(start);
        end.setMonth(end.getMonth() + 1);
        end.setDate(end.getDate() - 1);
        return end;
      })(),
      oxygen_start: new Date(),
      oxygen_end: (() => {
        const start = new Date();
        const end = new Date(start);
        end.setFullYear(end.getFullYear() + 1);
        end.setDate(end.getDate() - 1);
        return end;
      })(),
      diabetes_start: new Date(),
      diabetes_end: (() => {
        const start = new Date();
        const end = new Date(start);
        end.setFullYear(end.getFullYear() + 1);
        end.setDate(end.getDate() - 1);
        return end;
      })(),
      manager: '',
      phone1: '',
      phone2: '',
      centername: '',
      deliveryMethod: '',
      delivery_time: '0',
      delivery_date: ''
    });
    const showModal_obj = reactive({
      client_up: ref(false),
      company_up: ref(false),
      product_up: ref(false),
      claim_up: ref(false),
      // image_up: ref(false)
    });
    const modal_width = {
      client_up: '65%',
      company_up: '65%',
      product_up: '85%',
      claim_up: '50%',
      // image_up: '65%'
    };
    const modal_height = {
      client_up: '80%',
      company_up: '80%',
      product_up: '80%',
      claim_up: '60%',
      // image_up: '80%'
    };
    const postcode_obj = reactive({
      postcode1: '',
      address1: '',
      detailAddress1: '',
      postcode2: '',
      address2: '',
      detailAddress2: '',
    });

    const ko = {
      formatLocale: {
        months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
        weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
        weekdaysMin: ['일', '월', '화', '수', '목', '금', '토'],
        firstDayOfWeek: 0,
        firstWeekContainsDate: 1,
        meridiem: (h) => (h < 12 ? '오전' : '오후'),
        meridiemParse: /오전|오후/,
        isPM: (input) => input === '오후'
      },
      yearFormat: 'YYYY년',
      monthFormat: 'MMM',
      monthBeforeYear: false
    };

    return {
      isInitialized,
      showModal_obj,
      modal_width,
      modal_height,
      postcode_obj,
      client_data_obj,
      products_obj,
      color_obj,
      orderComment,
      clientUpBtn,
      priceInputs,
      store_products,
      storePaymentMethod,
      openStoreProductModal,
      openClaimModal,
      ko
    };
  },

  data() {
    return {
      manager: '없음',
      orderDate: new Date(),
      imageFiles: [],
      format: {
        price: (price) => {
          return new Intl.NumberFormat('ko-KR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(price);
        },
        date: (dateString) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        },
      },
      barcode: '',
      showClientModal: false,
      showProductModal: false,
      storePriceInputs: {},  // 매장 단가 input 요소 참조를 저장할 객체
      // 품목 이미지 미리보기
      imagePreviewUrl: null,
      imagePreviewTimer: null,
      imagePreviewStyle: {
        top: '0px',
        left: '0px'
      }
    };
  },

  computed: {
    isTestUser() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        return userInfo && userInfo.id === 'test';
      } catch (error) {
        return false;
      }
    },
    // 낱개 당 가격 계산 함수
    calculateUnitPrice() {
      return (product) => {
        if (!product || product.type !== '박스') return 0;

        const buyPrice = parseInt(product.buyprice || product.price || 0);
        const piecesPerBox = parseInt(product.pieces_per_box || 0);

        if (piecesPerBox <= 0) return 0;

        // 낱개 당 가격 = 구입가격 / 박스 당 개수
        const unitPrice = Math.round(buyPrice / piecesPerBox);
        return this.format.price(unitPrice);
      };
    },
    // 합계 수량 계산 함수
    calculateTotalQuantity() {
      return (product) => {
        if (!product) return 0;

        const quantity = parseInt(product.quantity) || 0;
        const pieceQuantity = parseInt(product.piece_quantity) || 0;

        if (product.type === '박스') {
          // 박스인 경우: (박스 수량 × 박스당 개수) + 낱개 수량
          const piecesPerBox = parseInt(product.pieces_per_box) || 0;
          return (quantity * piecesPerBox) + pieceQuantity;
        } else {
          // 낱개인 경우: 품목 수량 + 낱개 수량
          return quantity + pieceQuantity;
        }
      };
    },
    // 모든 제품이 선택되었는지 확인
    isAllSelected() {
      if (this.products_obj.length === 0) return false;
      return this.products_obj.every(product => product.selected);
    },
    // 대여 품목 존재 여부 체크
    hasRentalProduct() {
      return this.store_products.some(product =>
        product.rental_id != null ||
        product.target === '대여' ||
        product.selected_target === '대여'
      );
    },
    hasOxygenGenerator() {
      return this.store_products.some(product =>
        product.name1 === "산소발생기" || product.name === "산소발생기"
      );
    },
    hasDiabetesProduct() {
      return this.store_products.some(product =>
        product.name1 === "당뇨용품" ||
        product.name === "당뇨용품" ||
        product.name0 === "당뇨용품(E)" ||
        (product.name && product.name.includes("당뇨용품"))
      );
    },
    // 매장 총 가격 계산
    totalStorePrice() {
      return this.store_products.reduce((total, product) => {
        const finalPrice = this.getFinalPrice(product);
        return total + (finalPrice * product.quantity);
      }, 0);
    },
    // 매장 총 수량 계산
    totalStoreQuantity() {
      return this.store_products.reduce((total, product) => total + (product.quantity || 0), 0);
    },
    // 총 수량 계산
    totalQuantity() {
      return this.store_products.reduce((total, product) => {
        return total + (product.quantity || 0);
      }, 0);
    },
    // 총 주문 금액 계산
    totalAmount() {
      return this.totalStorePrice;
    },
  },

  methods: {
    // 청구 계산용 선택된 품목 데이터 가져오기
    getSelectedProductsForClaim() {
      return this.store_products
        .filter(product => product.selected)
        .map(product => ({
          id: product.num || product.b_product_id,
          name: product.name2 || product.name || '품목명 없음',
          price: product.unitprice || product.buyprice || product.price || 0,
          quantity: product.quantity || 0,
          target: product.selected_target || product.target || '구입',
          company: product.company || '',
          code: product.code || '',
          bcode: product.bcode || '',
          // 박스 타입 정보 추가
          type: product.type || '낱개',
          pieces_per_box: product.pieces_per_box || 1,
          // 당뇨 관련 정보
          isDiabetes: this.isDiabetesProduct(product),
          // 산소발생기 관련 정보
          isOxygen: this.isOxygenProduct(product),
          // 보조기기 관련 정보
          isAssistance: this.isAssistanceProduct(product)
        }));
    },

    // 당뇨소모성재료 품목인지 확인
    isDiabetesProduct(product) {
      return product.name1 === "당뇨용품" ||
        product.name === "당뇨용품" ||
        product.name0 === "당뇨용품(E)" ||
        (product.name && product.name.includes("당뇨용품")) ||
        (product.name2 && product.name2.includes("당뇨"));
    },

    // 산소발생기 품목인지 확인
    isOxygenProduct(product) {
      return product.name1 === "산소발생기" ||
        product.name === "산소발생기" ||
        (product.name && product.name.includes("산소"));
    },

    // 보조기기 품목인지 확인
    isAssistanceProduct(product) {
      return product.name1 === "보조기기" ||
        product.name === "보조기기" ||
        (product.name && product.name.includes("보조기기")) ||
        (product.name && product.name.includes("지팡이")) ||
        (product.name && product.name.includes("목발")) ||
        (product.name && product.name.includes("워커"));
    },

    // 청구 계산 모달 열기
    openClaimModal() {
      // 기본 유효성 검사
      if (this.store_products.length === 0) {
        this.$swal.fire({
          title: '품목 없음',
          text: '청구 계산할 품목이 없습니다. 품목을 먼저 추가해주세요.',
          icon: 'warning',
          confirmButtonText: '확인'
        });
        return;
      }

      // 선택된 품목이 있는지 확인
      const selectedProducts = this.getSelectedProductsForClaim();
      if (selectedProducts.length === 0) {
        this.$swal.fire({
          title: '선택된 품목 없음',
          text: '청구 계산할 품목을 선택해주세요.',
          icon: 'warning',
          confirmButtonText: '확인'
        });
        return;
      }

      // 수급자 정보 확인
      if (!this.client_data_obj.name || !this.client_data_obj.number) {
        this.$swal.fire({
          title: '수급자 정보 미입력',
          text: '청구 계산을 위해 수급자 정보를 먼저 입력해주세요.',
          icon: 'warning',
          confirmButtonText: '확인',
          didOpen: () => {
            const clientUpBtn = document.querySelector('.clientUpBtn');
            if (clientUpBtn) {
              clientUpBtn.classList.add('buzz');
              setTimeout(() => {
                clientUpBtn.classList.remove('buzz');
              }, 750);
            }
          }
        });
        return;
      }

      // 바코드 스캐너 비활성화 및 모달 열기
      this.disableBarcodeScanner();
      this.showModal_obj.claim_up = true;
    },

    // 청구 계산 모달 닫기
    handleClaimModalClose() {
      this.showModal_obj.claim_up = false;
      this.enableBarcodeScanner();
    },

    // 가격 포맷팅
    formatPrice(price) {
      return new Intl.NumberFormat('ko-KR').format(price || 0);
    },

    // 제품 확장/축소 토글
    toggleProductExpand(index) {
      const product = this.products_obj[index];

      // 현재 제품 확장/축소
      product.expanded = !product.expanded;

      // 모든 제품이 확장되어 있는지 확인하여 showAllDetails 상태 업데이트
      const allExpanded = this.products_obj.every(product => product.expanded);
      const noneExpanded = this.products_obj.every(product => !product.expanded);

      if (allExpanded) {
        this.showAllDetails = true;
      } else if (noneExpanded) {
        this.showAllDetails = false;
      }
    },
    perItemTotalPrice(product) {
      const unitPrice = Number(product.unitprice) || 0;
      const quantity = Number(product.quantity) || 0;
      return unitPrice * quantity;
    },
    // 품목 삭제 메서드
    deleteProduct(index) {
      const product = this.products_obj[index];
      this.products_obj.splice(index, 1);
    },

    showProductImage(event, product) {
      // 기존 타이머가 있으면 취소
      if (this.imagePreviewTimer) {
        clearTimeout(this.imagePreviewTimer);
        this.imagePreviewTimer = null;
      }

      if (!product) return;

      // 이벤트 대상이 image-trigger 클래스를 가진 요소이거나 그 자식인지 확인
      const triggerElement = event.target.closest('.image-trigger');
      if (!triggerElement) return;

      // 마우스 위치 기준으로 이미지 위치 계산
      const rect = triggerElement.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

      // 이미지 위치 설정
      this.imagePreviewStyle = {
        top: `${rect.top + scrollTop - 100}px`,
        left: `${rect.left + scrollLeft - 250}px`,
        zIndex: 1000
      };

      const timestamp = new Date().getTime();
      const s3BaseUrl = process.env.VUE_APP_S3_BUCKET;

      // 즉시 이미지 URL 설정 (존재 여부 확인 없이)
      let imageUrl = null;

      // 1. num으로 먼저 시도
      if (product.b_product_id) {
        imageUrl = `${s3BaseUrl}/Product-image/${product.b_product_id}.jpg?t=${timestamp}`;
      }
      // 2. code로 시도 (b_product_id가 없는 경우)
      else if (product.code?.trim()) {
        imageUrl = `${s3BaseUrl}/Product-image/${product.code}.jpg?t=${timestamp}`;
      }
      // 3. 기본 이미지
      else {
        imageUrl = `${s3BaseUrl}/Product-image/icon.png`;
      }

      this.imagePreviewUrl = imageUrl;

      // 이미지 로드 실패 시 기본 이미지로 fallback
      const img = new Image();
      img.onload = () => {
        // 이미지 로드 성공 - 이미 설정된 URL 유지
      };
      img.onerror = () => {
        // 이미지 로드 실패 시 기본 이미지로 변경
        if (this.imagePreviewUrl === imageUrl) {
          this.imagePreviewUrl = `${s3BaseUrl}/Product-image/icon.png`;
        }
      };
      img.src = imageUrl;
    },
    hideProductImage() {
      this.imagePreviewTimer = setTimeout(() => {
        this.imagePreviewUrl = null;
      }, 50);
    },
    // ------------ 단가 수정 관련 메서드 ------------
    startEditingPrice(index, type) {
      const product = this.store_products[index];
      product.isEditingPrice = true;

      // 기존 단가를 저장 (처음 수정할 때만)
      if (!product.originalUnitPrice) {
        product.originalUnitPrice = product.unitprice;
      }

      this.disableBarcodeScanner();
      this.$nextTick(() => {
        if (this.priceInputs[index]) {
          this.priceInputs[index].focus();
          this.priceInputs[index].select();
        }
      });
    },
    updatePrice(index, value, type) {
      const product = this.store_products[index];
      const newPrice = Number(value.replace(/[^0-9]/g, ''));
      product.unitprice = newPrice;

      // 구입/대여 타입에 따라 해당 가격도 업데이트
      if (product.selected_target === '대여') {
        product.rentprice = newPrice;
      } else {
        product.buyprice = newPrice;
      }
    },
    finishEditingPrice(index, type) {
      const product = this.store_products[index];
      product.isEditingPrice = false;
      this.enableBarcodeScanner();
    },

    getTotalPriceDifference(product) {
      // 선택된 타겟이 대여인지 구입인지 확인
      const isRental = product.selected_target === '대여';

      // 원래 가격이 설정되어 있지 않으면 0 반환
      if (product.originalBuyPrice === undefined && product.originalRentPrice === undefined) {
        return 0;
      }

      if (isRental) {
        // 대여인 경우
        const originalRentPrice = Number(product.originalRentPrice || 0);
        const currentRentPrice = Number(product.rentprice || product.price2 || 0);
        const quantity = Number(product.quantity || 0);

        // 대여 단가 차이 × 수량
        const priceDifference = currentRentPrice - originalRentPrice;
        return priceDifference * quantity;
      } else {
        // 구입인 경우
        const originalBuyPrice = Number(product.originalBuyPrice || 0);
        const currentBuyPrice = Number(product.buyprice || product.price || 0);
        const quantity = Number(product.quantity || 0);

        // 구입 단가 차이 × 수량
        const priceDifference = currentBuyPrice - originalBuyPrice;
        return priceDifference * quantity;
      }
    },

    // ------------ 공통 메서드 ------------
    getFinalPrice(product) {
      return this.getTotalPriceDifference(product);
    },

    getFinalPrice(product) {
      return product.finalPrice || product.unitprice;
    },

    // ------------ 품목 선택 관련 메서드 ------------
    handleTargetSelection(target, productId) {
      // products_obj 배열에서 해당 제품을 찾아 selected_target 업데이트
      const product = this.products_obj.find(p => p.id === productId);
      if (product) {
        product.selected_target = target;

        // 단가도 함께 업데이트
        if (target === '대여') {
          product.unitprice = product.rentprice;
        } else if (target === '구입') {
          product.unitprice = product.buyprice;
        }
      }
    },

    // 수량 및 가격 관련 메서드
    handleQuantityChange(product, index, newValue, productsArray) {
      // 비급여 품목(product.num이 100000 이상)인 경우 수량만 변경
      if (product.num >= 100000) {
        const newQuantity = parseInt(newValue) || 1;
        if (newQuantity < 1) {
          product.quantity = 1;
        } else {
          product.quantity = newQuantity;
        }

        // 가격 업데이트
        if (product.target === '대여') {
          product.setRentprice = product.rentprice * product.quantity;
        } else {
          product.setUnitprice = product.unitprice * product.quantity;
          product.setBuyprice = product.buyprice * product.quantity;
        }

        productsArray[index] = { ...product };
        return; // 비급여 품목은 여기서 종료
      }

      // 급여 품목인 경우 기존 로직 실행
      // 배열 초기화 확인
      if (!Array.isArray(product.barcodes)) product.barcodes = [''];
      if (!Array.isArray(product.sizes)) product.sizes = [''];
      if (!Array.isArray(product.colors)) product.colors = [''];
      if (!Array.isArray(product.notes)) product.notes = [''];

      // quantity가 직접 변경되었을 수 있으므로 현재 배열 길이를 기준으로 사용
      const currentArrayLength = Math.max(
        product.barcodes.length,
        product.sizes.length,
        product.colors.length,
        product.notes.length
      );

      const oldQuantity = currentArrayLength; // 현재 배열 길이를 이전 수량으로 사용
      const newQuantity = parseInt(newValue) || 1;

      if (newQuantity < 1) {
        product.quantity = 1;
        return;
      }

      if (newQuantity > oldQuantity) {
        // 마지막 입력값 가져오기 (배열의 마지막 값을 사용)
        const lastBarcode = product.barcodes.length > 0 ? product.barcodes[product.barcodes.length - 1] : '';
        const lastSize = product.sizes.length > 0 ? product.sizes[product.sizes.length - 1] : '';
        const lastColor = product.colors.length > 0 ? product.colors[product.colors.length - 1] : '';
        const lastNote = product.notes.length > 0 ? product.notes[product.notes.length - 1] : '';

        // 새로운 항목 추가
        for (let i = oldQuantity; i < newQuantity; i++) {
          product.barcodes.push(lastBarcode);
          product.sizes.push(lastSize);
          product.colors.push(lastColor);
          product.notes.push(lastNote);
        }
      } else if (newQuantity < oldQuantity) {
        // 수량 감소 시 배열 요소 제거
        product.barcodes.splice(newQuantity);
        product.sizes.splice(newQuantity);
        product.colors.splice(newQuantity);
        product.notes.splice(newQuantity);
      }

      // 가격 업데이트
      if (product.target === '대여') {
        product.setRentprice = product.rentprice * newQuantity;
      } else {
        product.setUnitprice = product.unitprice * newQuantity;
        product.setBuyprice = product.buyprice * newQuantity;
      }

      product.quantity = newQuantity;
      productsArray[index] = { ...product };
    },

    // 매장 수량/가격 관련 메서드
    handleStoreQuantityChange(index, newValue) {
      const product = this.store_products[index];
      this.handleQuantityChange(product, index, newValue, this.store_products);
    },
    increaseStoreQuantity(index) {
      const product = this.store_products[index];
      if (!product) return;
      product.quantity = (parseInt(product.quantity) || 1) + 1;
      this.handleQuantityChange(product, index, product.quantity, this.store_products);
    },
    decreaseStoreQuantity(index) {
      const product = this.store_products[index];
      if (!product || product.quantity <= 1) return;
      product.quantity = parseInt(product.quantity) - 1;
      this.handleQuantityChange(product, index, product.quantity, this.store_products);
    },

    // ============= 바코드 스캔 관련 메서드 =============
    disableBarcodeScanner() {
      try {
        if (document && document.scannerDetectionData) {
          onScan.detachFrom(document);
        }
      } catch (error) {
        console.log('바코드 스캐너 비활성화 중 오류:', error);
      }
    },
    enableBarcodeScanner() {
      this.initBarcodeScanner();
    },
    initBarcodeScanner() {
      try {
        onScan.detachFrom(document);
      } catch (e) {
        console.log('스캐너 초기화');
      }

      onScan.attachTo(document, {
        suffixKeyCodes: [13], // Enter key
        reactToPaste: false,
        onScan: (sCode) => {
          console.log('바코드 스캔 감지!', sCode);
          this.handleScan(sCode);
        },
        onScanError: (error) => {
          console.error('스캔 오류:', error);
        },
        onKeyDetect: (keyCode) => {
          console.log('감지된 키:', keyCode);
        },
        timeBeforeScanTest: 300,
        avgTimeByChar: 300,
        minLength: 6,
        scanButtonKeyCode: false,
        scanButtonLongPressThreshold: 500,
        stopPropagation: true,
        preventDefault: true,
      });
    },

    // 바코드 스캔
    async handleScan(sCode) {
      try {
        console.log('스캔된 바코드:', sCode);

        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/ProductCodeMapping`, {
          bcode: sCode,
          companykey: this.$globalState.company_key
        });

        console.log('매핑 응답:', response.data);

        if (response.data.statusCode === 200 && response.data.success && response.data.data) {
          const responseData = response.data.data;

          // 새로운 응답 구조에서 products 배열 확인
          if (responseData.products && Array.isArray(responseData.products)) {
            const products = responseData.products;

            if (products.length === 1) {
              // 단일 제품인 경우 기존 로직 사용
              await this.processSingleProduct(products[0], sCode);
            } else if (products.length > 1) {
              // 여러 제품인 경우 사용자 선택 또는 모두 추가
              await this.processMultipleProducts(products, sCode);
            }
          } else {
            // 이전 응답 구조와의 호환성을 위한 처리
            await this.processSingleProduct(responseData, sCode);
          }
        }
      } catch (error) {
        console.error('바코드 스캔 오류:', error);
        await this.$swal.fire({
          icon: 'error',
          title: '바코드 스캔 실패',
          text: '바코드 매칭에 실패했습니다.',
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            container: 'custom-toast-container',
            popup: 'custom-toast-popup',
            title: 'custom-toast-title',
          }
        });
      }
    },

    // 단일 제품 처리 (기존 로직)
    async processSingleProduct(productData, sCode) {
      // productlist 데이터 형식을 b_productlist 형식과 일치시키기
      if (productData.name && !productData.name2) {
        productData = {
          ...productData,
          name2: productData.name,      // 품목
          name3: productData.name2,     // 품목명
          price: productData.buyprice || productData.price || 0,
          price2: productData.rentprice || productData.price2 || 0
        };
      }

      // 기존 제품 확인
      const existingProductIndex = this.store_products.findIndex(p => {
        // 정확한 코드 매칭
        if (p.code === productData.code) return true;
        // 바코드 앞부분 매칭 (productlist 테이블용)
        if (productData.code && sCode.startsWith(productData.code)) return true;
        return false;
      });

      if (existingProductIndex !== -1) {
        // 기존 제품이 있는 경우
        const existingProduct = this.store_products[existingProductIndex];
        const emptyBarcodeIndex = existingProduct.barcodes.findIndex(b => !b);

        if (emptyBarcodeIndex !== -1) {
          // 빈 바코드 슬롯이 있는 경우 해당 슬롯 업데이트
          existingProduct.barcodes[emptyBarcodeIndex] = sCode;
          existingProduct.sizes[emptyBarcodeIndex] = productData.size || '';
          existingProduct.colors[emptyBarcodeIndex] = productData.color || '';
          existingProduct.notes[emptyBarcodeIndex] = productData.note || '';
        } else {
          // 수량 증가 및 새 바코드 정보 추가
          existingProduct.quantity++;
          existingProduct.barcodes.push(sCode);
          existingProduct.sizes.push(productData.size || '');
          existingProduct.colors.push(productData.color || '');
          existingProduct.notes.push(productData.note || '');
        }
      } else {
        // 새 제품 추가
        this.addNewProductToStore(productData, sCode);
      }

      // 성공 알림
      await this.$swal.fire({
        icon: 'success',
        title: '바코드 스캔 성공',
        text: productData.name3 || productData.name2,
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          container: 'custom-toast-container',
          popup: 'custom-toast-popup',
          title: 'custom-toast-title',
        }
      });
    },

    // 여러 제품 처리
    async processMultipleProducts(products, sCode) {
      // 옵션 1: 모든 제품을 자동으로 추가
      if (products.length <= 2) {
        // 2개 이하인 경우 모두 자동 추가
        for (const productData of products) {
          await this.addNewProductToStore(productData, sCode);
        }

        await this.$swal.fire({
          icon: 'success',
          title: '바코드 스캔 성공',
          html: `${products.length}개의 제품이 추가되었습니다:<br>${products.map(p => `• ${p.name3}`).join('<br>')}`,
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            container: 'custom-toast-container',
            popup: 'custom-toast-popup',
            title: 'custom-toast-title',
          }
        });
      } else {
        // 옵션 2: 3개 초과인 경우 사용자 선택 모달 표시
        await this.showProductSelectionModal(products, sCode);
      }
    },

    // 제품 선택 모달 표시
    async showProductSelectionModal(products, sCode) {
      const productListHtml = products.map((product, index) => `
        <div style="display: flex; align-items: center; padding: 8px; border-bottom: 1px solid #eee;">
          <input type="checkbox" id="product_${index}" value="${index}" style="margin-right: 10px;" checked>
          <label for="product_${index}" style="flex: 1; text-align: left; cursor: pointer;">
            <strong>${product.name3}</strong><br>
            <small style="color: #666;">모델명: ${product.name4} | 사이즈: ${product.size || '-'} | 색상: ${product.color || '-'}</small>
          </label>
        </div>
      `).join('');

      const result = await this.$swal.fire({
        title: `동일한 바코드를 가진 품목 스캔`,
        html: `
          <div style="text-align: left; max-height: 400px; overflow-y: auto;">
            <p style="margin-bottom: 15px; color: #666;">추가할 품목을 선택하세요:</p>
            ${productListHtml}
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: '선택 품목 추가',
        cancelButtonText: '취소',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        width: '500px',
        preConfirm: () => {
          const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
          const selectedIndexes = Array.from(checkboxes).map(cb => parseInt(cb.value));

          if (selectedIndexes.length === 0) {
            this.$swal.fire({
              icon: 'warning',
              title: '최소 1개 제품을 선택해주세요.',
              confirmButtonColor: '#3085d6',
              confirmButtonText: '확인',
            });
            return false;
          }

          return selectedIndexes;
        }
      });

      if (result.isConfirmed && result.value) {
        const selectedProducts = result.value.map(index => products[index]);

        // 선택된 제품들 추가
        for (const productData of selectedProducts) {
          await this.addNewProductToStore(productData, sCode);
        }

        await this.$swal.fire({
          icon: 'success',
          title: '품목 추가 완료',
          html: `${selectedProducts.map(p => `• ${p.name3}`).join('<br>')}`,
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            container: 'custom-toast-container',
            popup: 'custom-toast-popup',
            title: 'custom-toast-title',
          }
        });
      }
    },

    // 새 제품을 매장 제품 목록에 추가
    addNewProductToStore(productData, sCode) {
      // productlist 데이터 형식을 b_productlist 형식과 일치시키기
      if (productData.name && !productData.name2) {
        productData = {
          ...productData,
          name2: productData.name,      // 품목
          name3: productData.name2,     // 품목명
          price: productData.buyprice || productData.price || 0,
          price2: productData.rentprice || productData.price2 || 0
        };
      }

      const processedProduct = {
        num: productData.num,
        code: productData.code,
        name: productData.name2,        // 품목
        name2: productData.name3,       // 품목명
        price: productData.price || 0,  // 기본 가격
        buyprice: productData.price || 0,  // 구매 가격
        rentprice: productData.price2 || productData.price || 0,  // 대여 가격, 없으면 구매가격 사용
        unitprice: productData.price || 0,  // 단가 추가
        setUnitprice: productData.price || 0,  // 단가 합계 추가
        target: productData.target || '구입',  // target이 없으면 기본값 '구입'
        company: productData.company,
        tax: productData.tax,

        // 옵션 정보
        colorOptions: productData.color ? productData.color.split(',') : [],
        sizeOptions: productData.size ? productData.size.split(',') : [],

        // 초기 수량 및 바코드 정보
        quantity: 1,
        barcodes: [sCode],
        sizes: [productData.size || ''],
        colors: [productData.color || ''],
        notes: [productData.note || ''],
        selected: false,
        showStockButton: false,

        // 추가 제품 정보
        b_product_id: productData.b_product_id || 0,
        piece_quantity: productData.piece_quantity || 0 // 낱개수량
      };

      this.store_products.push(processedProduct);
    },

    // ============= 이미지 처리 관련 메서드 =============
    imageHandlingOnFileSelected(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.imageFiles.push(files[i]);
      }
    },
    imageHandlingGetImageUrl(file) {
      console.log(URL.createObjectURL(file));
      return URL.createObjectURL(file);
    },
    imageHandlingRemoveImage(index) {
      this.imageFiles.splice(index, 1);
    },

    // ============= 수량 증가/감소 관련 메서드 =============
    increaseQuantity(index) {
      const product = this.store_products[index];
      if (!product) return; // 제품이 없으면 리턴

      if (!product.quantity) {
        product.quantity = 1;
      }
      if (!product.barcodes) {
        product.barcodes = [''];
      }
      if (!product.sizes) {
        product.sizes = [''];
      }
      if (!product.colors) {
        product.colors = [''];
      }
      if (!product.notes) {
        product.notes = [''];
      }

      product.quantity++;
      product.barcodes.push('');

      if (product.sizeOptions && product.sizeOptions.length > 0) {
        const lastSelectedSize = product.sizes[product.sizes.length - 1] || product.sizeOptions[0];
        product.sizes.push(lastSelectedSize);
      }
      if (product.colorOptions && product.colorOptions.length > 0) {
        const lastSelectedColor = product.colors[product.colors.length - 1] || product.colorOptions[0];
        product.colors.push(lastSelectedColor);
      }

      const lastNote = product.notes[product.notes.length - 1] || product.note || '';
      product.notes.push(lastNote);

      // 가격 업데이트
      if (product.target === '대여') {
        product.setRentprice = product.rentprice * product.quantity;
      } else {
        product.setUnitprice = product.unitprice * product.quantity;
        product.setBuyprice = product.buyprice * product.quantity;
      }
    },
    decreaseQuantity(index) {
      const product = this.store_products[index];
      if (!product) return;

      if (product.quantity > 1) {
        product.quantity--;
        product.barcodes.pop();
        product.sizes.pop();
        product.colors.pop();
        product.notes.pop();

        // 가격 업데이트
        if (product.target === '대여') {
          product.setRentprice = product.rentprice * product.quantity;
        } else {
          product.setUnitprice = product.unitprice * product.quantity;
          product.setBuyprice = product.buyprice * product.quantity;
        }
      } else {
        // 수량이 1 이하면 제품 제거
        products.splice(index, 1);
      }
    },

    checkClientInfoAndOpenModal() {
      if (!this.client_data_obj.name || !this.client_data_obj.number) {
        this.$swal.fire({
          title: '수급자 정보 미입력',
          text: '수급자 불러오기를 진행해주세요',
          icon: 'warning',
          confirmButtonText: '확인',
          didOpen: () => {
            const clientUpBtn = document.querySelector('.clientUpBtn');
            if (clientUpBtn) {
              clientUpBtn.classList.add('buzz');
              setTimeout(() => {
                clientUpBtn.classList.remove('buzz');
              }, 750); // 애니메이션 지속 시간과 일치
            }
          }
        });
      } else {
        this.disableBarcodeScanner();
        this.showModal_obj.product_up = true;
      }
    },
    async getManager() {
      try {
        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/companyMember/${this.$globalState.company_key}`, {
        });
        const data = response.data;
        if (data.code === 200) {
          this.manager = data.data;
        } else {
          this.manager = '';
        }
      } catch (error) {
        console.error('매니저 정보 가져오기 실패:', error);
      }
    },
    async getColorTable() {
      try {
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/colorTableGet`, {});
        const data = response.data;

        if (data.code === 200) {
          const newColorObj = {};
          data.data.forEach((obj) => {
            newColorObj[String(obj.num)] = obj.name;
          });
          this.color_obj.value = newColorObj;
        }
      } catch (error) {
        console.error('색상 테이블 가져오기 실패:', error);
      }
    },

    // 다음 우편번호 서비스 스크립트 동적 로딩
    loadDaumPostcodeScript() {
      return new Promise((resolve, reject) => {
        // 이미 로드되어 있으면 바로 resolve
        if (window.daum && window.daum.Postcode) {
          resolve();
          return;
        }

        // 스크립트가 이미 추가되어 있는지 확인
        const existingScript = document.querySelector('script[src*="postcode.v2.js"]');
        if (existingScript) {
          existingScript.onload = resolve;
          existingScript.onerror = reject;
          return;
        }

        // 새 스크립트 태그 생성
        const script = document.createElement('script');
        script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
        script.onload = resolve;
        script.onerror = reject;

        document.head.appendChild(script);
      });
    },

    // 개선된 주소 검색 함수
    async openDaumPostcode(type) {
      try {
        // 다음 우편번호 서비스 로드 확인
        await this.loadDaumPostcodeScript();

        const width = 500;
        const height = 600;
        const left = Math.ceil((window.innerWidth - width) / 2);
        const top = Math.ceil((window.innerHeight - height) / 2);

        new window.daum.Postcode({
          oncomplete: (data) => {
            if (type == 1) {
              this.postcode_obj.postcode1 = data.zonecode;
              this.postcode_obj.address1 = data.address;
              this.postcode_obj.detailAddress1 = data.buildingName;
            } else {
              this.postcode_obj.postcode2 = data.zonecode;
              this.postcode_obj.address2 = data.address;
              this.postcode_obj.detailAddress2 = data.buildingName;
            }
          },
          width: width,
          height: height,
          left: left,
          top: top
        }).open();

      } catch (error) {
        console.error('주소 검색 서비스 로딩 실패:', error);
        this.$swal.fire({
          title: '오류',
          text: '주소 검색 서비스를 불러올 수 없습니다.\n인터넷 연결을 확인하고 다시 시도해주세요.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    handleClientDetail(client) {
      this.postcode_obj.postcode1 = client.addressnum;
      this.postcode_obj.address1 = client.address;
      this.postcode_obj.detailAddress1 = client.addressdetail;

      for (const key in client) {
        if (Object.hasOwnProperty.call(client, key)) {
          const data = client[key];
          this.client_data_obj[key] = data;
        }
      }
    },

    handleCompanyDetail(company) {
      if (company && company.company) {
        this.client_data_obj.centername = company.company;
        this.client_data_obj.name = company.company;
        this.client_data_obj.phone1 = company.phone2;
        this.postcode_obj.address1 = company.address2;
        this.$swal.fire({
          title: '거래처 선택 완료',
          text: '거래처 정보가 성공적으로 선택되었습니다.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        });
      }
      this.showModal_obj.company_up = false;
    },

    removeBarcodeField(productIndex, barcodeIndex) {
      const product = this.store_products[productIndex];

      if (!product) return;

      // 배열에서 해당 인덱스의 데이터 제거
      product.barcodes.splice(barcodeIndex, 1);
      product.sizes.splice(barcodeIndex, 1);
      product.colors.splice(barcodeIndex, 1);
      product.notes.splice(barcodeIndex, 1);
      product.quantity--;

      // 수량이 0이 되면 제품 자체를 삭제
      if (product.quantity <= 0) {
        products.splice(productIndex, 1);
      }
    },

    handleProductDetail(product) {
      console.log('OrderUpPage - 전달받은 데이터:', product);

      if (!product) {
        console.error('제품 데이터가 없습니다.');
        return;
      }

      // 대여/구입 여부 확인
      const isRental = product.rental_id != null ||
        product.target === '대여' ||
        (product.target === '구입 또는 대여' && product.selected_target === '대여');

      const isPurchase = product.target === '구입' ||
        (product.target === '구입 또는 대여' && product.selected_target === '구입');

      // 선택된 거래 유형과 제품의 거래 유형이 일치하지 않으면 경고
      if ((isRental && product.selected_target === '구입') ||
        (isPurchase && product.selected_target === '대여')) {
        this.$swal.fire({
          icon: 'warning',
          title: '거래 유형 불일치',
          text: `선택하신 제품은 ${product.selected_target} 전용 상품입니다.`,
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });
        return;
      }

      // 바코드 정보 설정 - 급여 품목(num < 1000000)인 경우 빈 바코드로 설정
      let barcodeInfo = [''];
      if (product.barcodes && Array.isArray(product.barcodes) && product.barcodes.length > 0) {
        // ProductGetModal에서 이미 설정된 barcodes 사용 (보험코드 포함)
        barcodeInfo = [...product.barcodes];
      } else if (product.num >= 1000000) {
        // 비급여 품목(b_product_list)의 경우 bcode 사용
        barcodeInfo = [product.bcode || ''];
      } else {
        // 급여 품목(product_list)의 경우 빈 바코드로 설정
        barcodeInfo = [''];
      }

      // 세트 품목인 경우 수량과 가격 처리
      const productQuantity = product.isSetItem ? (product.quantity || 1) : 1;
      const productBuyprice = product.isSetItem ? (product.buyprice || product.price || 0) : (product.buyprice || 0);
      const productRentprice = product.isSetItem ? (product.rentprice || 0) : (product.rentprice || 0);

      // 기본 제품 설정
      const newProduct = {
        ...product,
        quantity: productQuantity, // 세트 품목의 경우 전달받은 수량 사용
        barcodes: barcodeInfo,
        notes: [''],
        selected: false,
        showStockButton: false,
        isEditingPrice: false,
        sizes: product.sizeOptions && product.sizeOptions.length > 0 ? [product.sizeOptions[0]] : [],
        colors: product.colorOptions && product.colorOptions.length > 0 ? [product.colorOptions[0]] : [],
        selected_target: product.selected_target || product.target,
        rentprice: productRentprice,
        buyprice: productBuyprice, // 세트 품목의 경우 전달받은 가격 사용
        setBuyprice: productBuyprice * productQuantity, // 총 가격 계산
        setRentprice: productRentprice * productQuantity,
        rental_id: isRental ? product.rental_id : null,

        // 원래 가격 저장 (차액 계산용)
        originalBuyPrice: productBuyprice,
        originalRentPrice: productRentprice,

        // 기존 단가 저장
        originalUnitPrice: productBuyprice,
        // 바코드 관련 추가 정보
        code: product.code || '',
        bcode: product.bcode || '',
        num: product.num,
        b_product_id: product.b_product_id || 0,
        // 세트 관련 정보
        product_set_id: product.product_set_id || null,
        isSetItem: product.isSetItem || false,
        set_name: product.set_name || '',
        piece_quantity: product.piece_quantity || 0, // 낱개수량
        // 급여 품목분류 표시를 위한 필드 추가
        pitem: product.pitem || '', // 품목분류
        pname: product.pname || '', // 품목
        pcode: product.pcode || '', // 품목코드
      };

      // 대여 상품인 경우 기본 대여 기간 설정
      if (isRental) {
        if (!this.client_data_obj.rental_start) {
          this.client_data_obj.rental_start = new Date();
        }
        if (!this.client_data_obj.rental_end) {
          const endDate = new Date();
          endDate.setMonth(endDate.getMonth() + 1);
          this.client_data_obj.rental_end = endDate;
        }
      }

      // 매장 제품인 경우 거래 유형 혼합 체크
      if ((isRental && this.store_products.some(p => p.selected_target === '구입')) ||
        (isPurchase && this.store_products.some(p => p.selected_target === '대여'))) {
        this.$swal.fire({
          icon: 'warning',
          title: '거래 유형 혼합 불가',
          text: '매장 주문에서는 대여와 구입 상품을 함께 주문할 수 없습니다.',
          confirmButtonText: '확인'
        });
        return;
      }

      // 모든 제품을 store_products에 추가 (대여/구입 구분 없이)
      this.store_products.push(newProduct);

      // 바코드 스캐너 재활성화
      this.enableBarcodeScanner();
    },

    // ============= 선택품목삭제 메서드 =============
    toggleProductSelection(index, type) {
      const product = this.store_products[index];

      if (product) {
        product.selected = !product.selected;
      }
    },

    // ============= 매장 주문품목 선택 관련 메서드 =============
    // 전체 선택/해제 토글
    toggleAllSelection() {
      if (this.isAllSelected) {
        this.deselectAllStore();
      } else {
        this.selectAllStore();
      }
    },
    selectAllStore() {
      this.store_products.forEach(product => product.selected = true);
    },
    deselectAllStore() {
      this.store_products.forEach(product => product.selected = false);
    },
    deleteSelectedStoreProducts() {
      this.store_products = this.store_products.filter(product => !product.selected);
    },

    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async commentFormDataSubmit(orderId) {
      const formData = new FormData();
      formData.append('manager', this.$globalState.manager_name);
      formData.append('text', this.orderComment);

      // 이미지 파일들을 개별적으로 FormData에 추가
      if (this.imageFiles && this.imageFiles.length > 0) {
        this.imageFiles.forEach((file) => {
          formData.append('files', file, file.name);
        });
      }

      // FormData 내용 확인
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      if (formData.entries().next().done) {
        console.error('FormData가 비어있습니다!');
        return; // FormData가 비어있으면 요청을 보내지 않음
      }
      const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/comment/${orderId}`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      console.log(response.data);
    },

    submitOrder(rental_type = '') {
      // rental_type: '' (일반), 'o' (산소발생기), 'a' (보장구), 'd' (당뇨소모성재료)
      this.processOrder(rental_type, false);
    },

    // 주문 처리 로직을 별도 메소드로 분리
    processOrder(rental_type, withClaim) {
      if (this.store_products.length === 0) {
        this.$swal.fire({
          title: '주문 실패',
          text: '주문할 품목이 없습니다. 품목을 추가해주세요.',
          icon: 'error',
          confirmButtonText: '확인'
        });
        return;
      }

      const formData = new FormData();
      formData.append('text', this.orderCommentAdd);

      // 이미지 파일들을 개별적으로 FormData에 추가
      if (this.imageFiles && this.imageFiles.length > 0) {
        this.imageFiles.forEach((file) => {
          formData.append('files', file, file.name);
        });
      }

      // FormData 내용 확인
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      // 대여 상품이 있는지 확인
      const hasRentalProduct = this.store_products.some(
        product => product.selected_target === '대여'
      );

      // 대여 상품이 있는데 대여 날짜가 없는 경우 체크
      if (hasRentalProduct && (!this.client_data_obj.rental_start || !this.client_data_obj.rental_end)) {
        this.$swal.fire({
          title: '주문 실패',
          text: '대여 상품이 포함되어 있습니다. 대여 시작일과 종료일을 입력해주세요.',
          icon: 'error',
          confirmButtonText: '확인'
        });
        return;
      }

      const orderProducts = this.store_products.map(product => {
        // 차액이 적용된 최종 가격 계산
        const finalPrice = Number(product.unitprice) || 0;

        return {
          ...product,
          selected_target: product.selected_target || product.target,
          // 대여/구입 여부에 따라 적절한 가격 필드에 최종 가격 할당
          rentprice: product.selected_target === '대여' ? finalPrice : null,
          buyprice: product.selected_target === '구입' ? finalPrice : null,
          unitprice: finalPrice
        };
      });

      // 주문 유형에 따른 메시지 설정
      let orderTypeMessage = '';
      switch (rental_type) {
        case 'o':
          orderTypeMessage = '산소발생기';
          break;
        case 'a':
          orderTypeMessage = '보장구';
          break;
        case 'd':
          orderTypeMessage = '당뇨소모성재료';
          break;
        default:
          orderTypeMessage = '';
      }

      const orderData = {
        orderdate: this.format.date(this.orderDate),
        name: this.client_data_obj.name,
        number: this.client_data_obj.number,
        resident: this.client_data_obj.regident,
        addressnum: this.postcode_obj.postcode1,
        address: this.postcode_obj.address1,
        addressdetail: this.postcode_obj.detailAddress1,
        addressnum2: this.postcode_obj.postcode2,
        address2: this.postcode_obj.address2,
        address2detail: this.postcode_obj.detailAddress2,
        email: this.client_data_obj.email,
        guardname: this.client_data_obj.guardname,
        guardtarget: this.client_data_obj.guardtarget,
        phone1: this.client_data_obj.phone1 ? this.client_data_obj.phone1.replace(/-/g, '') : '',
        phone2: this.client_data_obj.phone2 ? this.client_data_obj.phone2.replace(/-/g, '') : '',
        centername: this.client_data_obj.centername,
        manager: this.client_data_obj.manager,
        rental_start: this.hasRentalProduct ? this.format.date(this.client_data_obj.rental_start) : null,
        rental_end: this.hasRentalProduct ? this.format.date(this.client_data_obj.rental_end) : null,
        // 산소발생기 버튼(rental_type === 'o')을 눌렀을 때만 oxygen 날짜 전송
        oxygen_start: rental_type === 'o' ? this.format.date(this.client_data_obj.oxygen_start) : null,
        oxygen_end: rental_type === 'o' ? this.format.date(this.client_data_obj.oxygen_end) : null,
        // 당뇨소모성재료 버튼(rental_type === 'd')을 눌렀을 때만 diabetes 날짜 전송
        diabetes_start: rental_type === 'd' ? this.format.date(this.client_data_obj.diabetes_start) : null,
        diabetes_end: rental_type === 'd' ? this.format.date(this.client_data_obj.diabetes_end) : null,
        rental_type: rental_type,
        business: "",
        delivery_method: this.getDeliveryMethodCode(this.client_data_obj.deliveryMethod),
        delivery_status: 2,
        delivery_date: this.format.date(this.client_data_obj.delivery_date),
        delivery_time: parseInt(this.client_data_obj.delivery_time),
        comment: this.orderComment,
        payment: this.storePaymentMethod || '현금',
        products: orderProducts.map(product => {
          // 급여 품목인지 확인 (pitem, pname, pcode가 있는 경우)
          const isWelfareProduct = product.pitem && product.pname && product.pcode;

          // 급여 품목인 경우 id를 product_id로 설정, 아닌 경우 기존 로직 사용
          const productId = isWelfareProduct ? product.id : (product.isSetItem ? null : product.num);

          return {
            id: productId,
            buyprice: product.selected_target === '구입' ? product.buyprice : null,
            rentprice: product.selected_target === '대여' ? product.rentprice : null,
            quantity: product.quantity,
            selected_target: product.selected_target,
            product_set_id: product.product_set_id || null,
            isSetItem: product.isSetItem || false, // 세트 품목 여부 표시
            price: product.price, // 세트 품목의 원래 가격
            set_item_id: product.isSetItem && product.set_items ?
              product.set_items.map(item => item.id).join(',') : null,
            options: {
              size: product.sizes,
              color: product.colors,
              note: product.notes,
              bcode: product.name0 === '당뇨용품(E)'
                ? product.barcodes.map(bcode => {
                  // 바코드에서 보험코드 부분 제거하고 원래 바코드만 전송
                  const match = bcode.match(/^([^\s(]+)/);
                  return match ? match[1] : bcode;
                })
                : product.barcodes,
              icode: product.name0 === '당뇨용품(E)'
                ? Array(product.quantity).fill(product.icode)
                : Array(product.quantity).fill(null)
            },
            // 급여 품목인 경우 추가 정보 포함
            ...(isWelfareProduct && {
              pitem: product.pitem,
              pname: product.pname,
              pcode: product.pcode
            })
          };
        }),
        member_id: this.$globalState.id,
        companykey: this.$globalState.company_key
      };

      console.log('주문 데이터:', orderData);
      console.log('제품 정보:', orderData.products);

      const token = localStorage.getItem('token');

      this.$axios.post(`${this.$apiUrls.hanqmedi}/order`, orderData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
        .then(async (response) => {

          // 댓글이나 이미지가 있을 경우 댓글 먼저 생성
          if (this.orderComment || this.imageFiles.length > 0) {
            try {
              await this.commentFormDataSubmit(response.data.orderId);
              // 댓글 생성 후 바로 부모 컴포넌트 데이터 갱신
              this.$emit('fetch-orders');
            } catch (error) {
              console.error('댓글 생성 중 오류:', error);
            }
          }

          // 성공 메시지 설정
          let successMessage = '주문이 성공적으로 제출되었습니다.';
          if (withClaim && orderTypeMessage) {
            successMessage = `주문 및 ${orderTypeMessage} 청구가 성공적으로 제출되었습니다.`;
          }

          this.$swal.fire({
            title: '주문 성공',
            text: successMessage,
            icon: 'success',
            confirmButtonText: '확인',
            allowOutsideClick: false,
          }).then((result) => {
            console.log("response.data.order_id", response.data.orderId);

            if (result.isConfirmed) {
              this.$emit('close-modal');
              this.$emit('fetch-orders');
            }
          });
        })
        .catch(error => {
          console.error('주문 제출 중 오류가 발생했습니다:', error);
          this.$swal.fire({
            title: '주문 실패',
            text: '주문 제출 중 오류가 발생했습니다. 다시 시도해주세요.',
            icon: 'error',
            confirmButtonText: '확인'
          });
        });
    },

    getDeliveryMethodCode(method) {
      const methodMap = {
        '내방': 1,
        '택배': 2,
        '물류 (기관배송)': 3,
        '소독': 4,
        '공급업체': 5
      };
      return methodMap[method] || 0;
    },
    convertToUpperCase(productIndex, sizeIndex) {
      if (this.products_obj[productIndex].sizes[sizeIndex]) {
        this.products_obj[productIndex].sizes[sizeIndex] =
          this.products_obj[productIndex].sizes[sizeIndex].toUpperCase();
      }
    },
    handleImageUploadClick() {
      this.disableBarcodeScanner();
      this.$refs.fileInput.click();
    },
  },

  mounted() {
    // 스타일을 동적으로 추가
    if (!document.getElementById('product-expanded-row-styles')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'product-expanded-row-styles';
      styleEl.textContent = ProductExpandedRowStyles;
      document.head.appendChild(styleEl);
    }

    this.getColorTable();
    this.getManager();
    this.initBarcodeScanner();
    document.addEventListener('keydown', this.handleEscKey);
  },
  unmounted() {
    this.disableBarcodeScanner();
    document.removeEventListener('keydown', this.handleEscKey);
  },
  created() {
    this.client_data_obj.manager = this.$globalState.manager_name;
    this.products_obj = this.store_products;
  },
  watch: {
    'showModal_obj.client_up': function (newVal) {
      if (newVal) {
        this.disableBarcodeScanner();
      } else {
        this.enableBarcodeScanner();
      }
    },
    'showModal_obj.product_up': {
      handler(newValue) {
        if (this.isInitialized && newValue === false) {
          this.enableBarcodeScanner();
        }
        if (!this.isInitialized) {
          this.isInitialized = true;
        }
        if (newValue) {
          this.disableBarcodeScanner();
        } else {
          this.enableBarcodeScanner();
        }
      },
      immediate: true
    },
    'showModal_obj.claim_up': function (newVal) {
      if (newVal) {
        this.disableBarcodeScanner();
      } else {
        this.enableBarcodeScanner();
      }
    },
  },
  name: 'OrderUpPage'
};
</script>

<style>
.custom-toast-title {
  margin-left: 0 !important;
  text-align: center !important;
  width: 100% !important;
  display: block !important;
}

.custom-toast-popup {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  overflow: hidden !important;
}

.swal2-toast .swal2-icon {
  margin: 0 auto !important;
}

.positive-diff {
  color: #28a745;
}

.negative-diff {
  color: #dc3545;
}
</style>